var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    fillRule: "evenodd",
    d: "M17.225 3.586a1.98 1.98 0 0 0-2.813 0l-9.705 9.702a7.2 7.2 0 0 0-1.194 1.71c-.499 1.061-.508 2.4-.512 2.956l-.003.52c0 .162.055.286.145.373a.5.5 0 0 0 .382.154l.52-.003c.556-.004 1.894-.013 2.956-.512a7.2 7.2 0 0 0 1.71-1.194l9.702-9.705a1.98 1.98 0 0 0 0-2.813zM5.003 18.003c.343 0 .625-.042.997-.14.484-.129.84-.334 1.317-.7l-2.481-2.482c-.366.477-.571.833-.7 1.317a3.6 3.6 0 0 0-.14.997zm3.043-1.508 7.398-7.346-2.594-2.594-7.346 7.398zm8.085-8.033 1.563-1.563a1 1 0 0 0 0-1.437l-1.157-1.157a1 1 0 0 0-1.437 0l-1.563 1.562z",
    clipRule: "evenodd"
  })));
};
export default SvgEditIcon;